import { useQuery } from '@tanstack/react-query';
import { Product } from '@ts/product';
import { QueryKeys } from '@utils/queries/queryKeys';
import { fetchProductRelationsAction } from '@actions/product/actions';

type UseLightsources = {
  product: Product;
  market: string;
};
export default function useLightsources({ product, market }: UseLightsources) {
  let lightsourceIds: string[] = [];
  if (product.relatedLightsources) {
    lightsourceIds = [...lightsourceIds, ...product.relatedLightsources];
  }
  if (product.recommendedLightsources) {
    lightsourceIds = [...lightsourceIds, ...product.recommendedLightsources];
  }

  return useQuery({
    queryKey: [QueryKeys.lightsources, lightsourceIds, market],
    queryFn: () => {
      if (!lightsourceIds.length) return [];

      return fetchProductRelationsAction({
        ids: lightsourceIds,
        market,
      });
    },
  });
}
